import React, { useEffect, useState } from "react";
import { Input, Modal, Checkbox, Spin } from "antd";
import axios from "axios";
import { DatePicker } from "antd";
import Maincomponent from "../../Components/Maincomponent/Maincomponent";
import Apiurl from "../../Apiurl";
import { Tabhelper } from "../../Helper/Tabhelper";
import Select from 'react-select'
import { useParams } from "react-router-dom";
import { RiExchangeFundsLine } from "react-icons/ri";

const { RangePicker } = DatePicker;

export default function Lead() {
    const [jsonList, setJsonList] = useState([]);
    const apiurl = Apiurl();
    const { user } = useParams();

    const [data, setData] = useState([]);
    const [dateRange, setDateRange] = useState([]);
    const [assignFilter, setAssignFilter] = useState(null);
    const [statusFilter, setStatusFilter] = useState(null);

    const [showAssignModal, setShowAssignModal] = useState(false);
    const [staffList, setStaffList] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState([]);
    const [unassignedCount, setUnassignedCount] = useState(0);
    const [assignPlan, setAssignPlan] = useState([]);
    const [schoolList, setSchoolList] = useState([]);
    const [selectedSchools, setSelectedSchools] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);

    // Reassignment Modal State
    const [showReassignModal, setShowReassignModal] = useState(false);
    const [reassignItem, setReassignItem] = useState(null);
    const [newAssignee, setNewAssignee] = useState(null);

    // Action Modal State
    const [actionModalVisible, setActionModalVisible] = useState(false);
    const [actionLoading, setActionLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState(null);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [actionRemarks, setActionRemarks] = useState("");

    // Rejection Reasons State
    const [rejectionReasons, setRejectionReasons] = useState({
        not_interested: false,
        already_joined_elsewhere: false,
        fees_too_high: false,
        course_not_relevant: false,
        parents_not_interested: false,
        prefers_online_classes: false,
        not_eligible_for_course: false,
        will_join_later: false,
        invalid_contact: false,
        no_response: false,
        duplicate_lead: false,
        out_of_service_area: false
    });

    // Status Progression State
    const [statusProgression, setStatusProgression] = useState({
        base_entry: false,
        verified: false,
        responded: false,
        qualified_lead: false,
        new_lead: false,
        contacted: false,
        info_shared: false,
        counselling_scheduled: false,
        demo_scheduled: false,
        counselling_done: false,
        demo_done: false,
        fees_discussion_ongoing: false,
        parent_approval_pending: false,
        form_issued: false,
        token_paid: false,
        full_payment_pending: false,
        converted: false
    });

    const handleActionClick = (action, id) => {
        setCurrentAction(action);
        setSelectedRowId(id);
        setActionRemarks("");
        // Reset rejection reasons when opening modal
        setRejectionReasons({
            not_interested: false,
            already_joined_elsewhere: false,
            fees_too_high: false,
            course_not_relevant: false,
            parents_not_interested: false,
            prefers_online_classes: false,
            not_eligible_for_course: false,
            will_join_later: false,
            invalid_contact: false,
            no_response: false,
            duplicate_lead: false,
            out_of_service_area: false
        });
        // Reset status progression when opening modal
        setStatusProgression({
            base_entry: false,
            verified: false,
            responded: false,
            qualified_lead: false,
            new_lead: false,
            contacted: false,
            info_shared: false,
            counselling_scheduled: false,
            demo_scheduled: false,
            counselling_done: false,
            demo_done: false,
            fees_discussion_ongoing: false,
            parent_approval_pending: false,
            form_issued: false,
            token_paid: false,
            full_payment_pending: false,
            converted: false
        });
        setActionModalVisible(true);
    };

    const submitAction = async () => {
        if (!selectedRowId) return;

        // Validation for "Not Interested" - at least one checkbox must be selected
        if (currentAction === 'Not Interested') {
            const hasSelectedReason = Object.values(rejectionReasons).some(value => value === true);
            if (!hasSelectedReason) {
                alert('Please select at least one rejection reason.');
                return;
            }
        }

        // Validation for "Prospect" - at least one checkbox must be selected
        if (currentAction === 'Prospect') {
            const hasSelectedStatus = Object.values(statusProgression).some(value => value === true);
            if (!hasSelectedStatus) {
                alert('Please select at least one status progression.');
                return;
            }
        }

        setActionLoading(true);
        try {
            const payload = {
                status: currentAction,
                lead_remarks: actionRemarks,
                lead_date: new Date().toISOString().split('T')[0]
            };

            // Add rejection reasons to payload if action is "Not Interested"
            if (currentAction === 'Not Interested') {
                Object.assign(payload, rejectionReasons);
            }

            // Add status progression to payload if action is "Prospect"
            if (currentAction === 'Prospect') {
                Object.assign(payload, statusProgression);
            }

            await axios.patch(apiurl + `basedataview/${selectedRowId}/`, payload);

            alert(`${currentAction} action submitted successfully!`);
            setActionModalVisible(false);
            fetchData();
        } catch (error) {
            console.error("Error submitting action:", error);
            alert("Failed to submit action.");
        } finally {
            setActionLoading(false);
        }
    };

    function convertToDDMMYYYY(timestamp) {
        const date = new Date(timestamp);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return year + "-" + month + "-" + day;
    }


    async function fetchData() {
        setLoading(true);
        try {
            const response = await axios.get(apiurl + `basedataview/?assigned_to=&status=Lead`);
            setData(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    async function fetchStaff() {
        try {
            const res = await axios.get(apiurl + "staffdetails/?Role=Marketing&Status=Active&Staffid=");
            const res2 = await axios.get(apiurl + "Schoollistapi/");
            setSchoolList(res2.data);
            setStaffList(res.data);
        } catch (e) {
            console.error(e);
        }
    }

    async function fetchFilterData() {
        const sdate =
            dateRange && dateRange[0]
                ? convertToDDMMYYYY(dateRange[0].toString())
                : "";
        const edate =
            dateRange && dateRange[1]
                ? convertToDDMMYYYY(dateRange[1].toString())
                : "";

        setLoading(true);
        try {
            const response = await axios.get(
                apiurl +
                `basedataview/?assigned_to=${assignFilter?.value}&status=${statusFilter}&start_date=${sdate}&end_date=${edate}`
            );
            setData(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
        fetchStaff();
    }, []);

    useEffect(() => {
        Tabhelper(
            {
                name: "Lead",
                link: "/lead",
                active: "no",
            },
            setJsonList
        );
    }, []);

    const openAssignModal = () => {
        setSelectedSchools([]);
        setSelectedStaff([]);
        setAssignPlan([]);
        setFilteredData([]);
        setUnassignedCount(0);
        setShowAssignModal(true);
    };

    // Reassignment handlers
    const handleReassignClick = (item) => {
        setReassignItem(item);
        setNewAssignee(null);
        setShowReassignModal(true);
    };

    const handleReassignSubmit = async () => {
        if (!reassignItem || !newAssignee) {
            alert('Please select a new assignee.');
            return;
        }

        try {
            await axios.patch(apiurl + `basedataview/${reassignItem.id}/`, {
                assigned_to: newAssignee.value
            });

            alert('Reassigned successfully!');
            setShowReassignModal(false);
            setReassignItem(null);
            setNewAssignee(null);
            fetchData();
        } catch (error) {
            console.error('Error reassigning:', error);
            alert('Failed to reassign.');
        }
    };

    const handleSchoolSelect = async (selectedOptions) => {
        setSelectedSchools(selectedOptions || []);

        if (!selectedOptions || selectedOptions.length === 0) {
            setFilteredData([]);
            setUnassignedCount(0);
            setAssignPlan([]);
            return;
        }

        const schoolNames = selectedOptions.map(s => s.label).join(",");

        try {
            const res = await axios.get(apiurl + `basedataview2/?schools=${schoolNames}`);
            setFilteredData(res.data);
            setUnassignedCount(res.data.length);

            // Recalculate plan if staff are already selected
            if (selectedStaff.length > 0) {
                calculatePlan(selectedStaff, res.data.length);
            }
        } catch (error) {
            console.error("Error fetching filtered data:", error);
            setFilteredData([]);
            setUnassignedCount(0);
        }
    };

    const calculatePlan = (staff, totalCount) => {
        if (staff.length === 0) {
            setAssignPlan([]);
            return;
        }

        const total = totalCount;
        const per = Math.floor(total / staff.length);
        const extra = total % staff.length;
        console.log(staff)

        let plan = staff.map((s, i) => ({
            staff: s,
            count: i === staff.length - 1 ? per + extra : per,
            staffname: s,
        }));

        setAssignPlan(plan);
    };

    const handleStaffSelect = (checkedValues) => {
        setSelectedStaff(checkedValues);
        console.log(checkedValues);
        calculatePlan(checkedValues, unassignedCount);
    };

    const confirmAssign = async () => {
        const unassigned = filteredData;

        // Step 1: Prepare staff assignment list (flat)
        const staffAssignments = assignPlan.flatMap(row =>
            Array.from({ length: row.count }, () => row.staff)
        );

        // Step 2: Pair with unassigned
        const assignments = unassigned
            .slice(0, staffAssignments.length)
            .map((row, i) => ({
                id: row.id,
                assigned_to: staffAssignments[i],
            }));

        console.log(assignments);

        if (assignments.length === 0) {
            alert("No data to assign!");
            return;
        }

        try {
            const response = await axios.patch(apiurl + "bulkbasedata/", assignments);


            console.log("Updated Data:", response.data.updated_data);
            alert("Assigned successfully!");
            setShowAssignModal(false);
            fetchData();

        } catch (error) {
            console.error(error);
            alert("Bulk assign failed!");
        }
    };


    const Tablecomp = (props) => {
        const [rowdata, setRowdata] = useState([]);
        const [postsPerPage] = useState(10);
        const [currentPage, setCurrentPage] = useState(1);
        const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
        const [statusFilter, setStatusFilter] = useState('All');
        const [assignedToFilter, setAssignedToFilter] = useState('All');

        useEffect(() => {
            setRowdata(props.data.slice(0).reverse());
        }, [props.data]);

        const handleSort = (key) => {
            let direction = 'ascending';
            if (sortConfig.key === key && sortConfig.direction === 'ascending') {
                direction = 'descending';
            }
            setSortConfig({ key, direction });
        };

        const sortedData = React.useMemo(() => {
            let sortableItems = [...rowdata];
            if (sortConfig.key) {
                sortableItems.sort((a, b) => {
                    if (a[sortConfig.key] < b[sortConfig.key]) {
                        return sortConfig.direction === 'ascending' ? -1 : 1;
                    }
                    if (a[sortConfig.key] > b[sortConfig.key]) {
                        return sortConfig.direction === 'ascending' ? 1 : -1;
                    }
                    return 0;
                });
            }
            return sortableItems;
        }, [rowdata, sortConfig]);

        const filteredData = React.useMemo(() => {
            let data = sortedData;
            if (statusFilter !== 'All') {
                data = data.filter(item => item.status === statusFilter);
            }
            if (assignedToFilter !== 'All') {
                data = data.filter(item => item.assigned_to_name === assignedToFilter);
            }
            return data;
        }, [sortedData, statusFilter, assignedToFilter]);

        const indexOfLastPage = currentPage * postsPerPage;
        const indexOfFirstPage = indexOfLastPage - postsPerPage;
        const currentPosts = filteredData.slice(indexOfFirstPage, indexOfLastPage);

        const totalPosts = filteredData.length;

        const showPagination = () => {
            const pageNumbers = [];
            for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
                pageNumbers.push(i);
            }

            return (
                <nav>
                    <ul className="pagination">
                        {pageNumbers.map((number) => (
                            <li
                                key={number}
                                className={currentPage === number ? "page-item active" : "page-item"}
                            >
                                <button
                                    onClick={() => setCurrentPage(number)}
                                    className="page-link"
                                >
                                    {number}
                                </button>
                            </li>
                        ))}
                    </ul>
                </nav>
            );
        };

        const getStatusBadge = (status) => {
            let color = '#007bf5ff';
            if (status === 'Lead') color = '#1890ff'; // Blue
            if (status === 'Prospect') color = '#52c41a'; // Green
            if (status === 'Followup') color = '#faad14'; // Orange
            if (status === 'Not Interested') color = '#f5222d'; // Red

            return (
                <span style={{
                    backgroundColor: color,
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '12px'
                }}>
                    {status || "Base"}
                </span>
            );
        };

        return (
            <div className="container">
                {loading ? (
                    <div style={{ textAlign: "center", padding: "50px" }}>
                        <Spin size="large" />
                    </div>
                ) : (
                    <table className="table align-items-center justify-content-center mb-0">
                        <thead>
                            <tr>
                                <th onClick={() => handleSort('id')} style={{ cursor: 'pointer' }}>S.No {sortConfig.key === 'id' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}</th>
                                <th onClick={() => handleSort('district')} style={{ cursor: 'pointer' }}>District {sortConfig.key === 'district' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}</th>
                                <th onClick={() => handleSort('school_id')} style={{ cursor: 'pointer' }}>School ID {sortConfig.key === 'school_id' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}</th>
                                <th onClick={() => handleSort('school_name')} style={{ cursor: 'pointer' }}>School Name {sortConfig.key === 'school_name' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}</th>
                                <th onClick={() => handleSort('student_name')} style={{ cursor: 'pointer' }}>Student Name {sortConfig.key === 'student_name' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}</th>
                                <th onClick={() => handleSort('student_class')} style={{ cursor: 'pointer' }}>Class {sortConfig.key === 'student_class' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}</th>
                                <th onClick={() => handleSort('gender')} style={{ cursor: 'pointer' }}>Gender {sortConfig.key === 'gender' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}</th>
                                <th onClick={() => handleSort('phone_1')} style={{ cursor: 'pointer' }}>Phone {sortConfig.key === 'phone_1' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}</th>
                                <th onClick={() => handleSort('entry_date')} style={{ cursor: 'pointer' }}>Entry Date {sortConfig.key === 'entry_date' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}</th>
                                <th>Source</th>
                                {user === "Super Admin" && <>
                                    <th>
                                        <select
                                            className="form-control"
                                            style={{ height: '30px', padding: '0 5px', fontSize: '12px' }}
                                            value={assignedToFilter}
                                            onChange={(e) => setAssignedToFilter(e.target.value)}
                                        >
                                            <option value="All">Assigned To (All)</option>
                                            {staffList.map((staff) => (
                                                <option key={staff.id} value={staff.Name}>
                                                    {staff.Name}
                                                </option>
                                            ))}
                                        </select>
                                    </th>
                                    <th>
                                        <select
                                            className="form-control"
                                            style={{ height: '30px', padding: '0 5px', fontSize: '12px' }}
                                            value={statusFilter}
                                            onChange={(e) => setStatusFilter(e.target.value)}
                                        >
                                            <option value="All">Status (All)</option>
                                            <option value="Lead">Lead</option>
                                            <option value="Prospect">Prospect</option>
                                            <option value="Followup">Followup</option>
                                        </select>
                                    </th>
                                </>}
                                <th>Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {currentPosts.length === 0 ? (
                                <tr>
                                    <td colSpan="13" style={{ textAlign: 'center', padding: '20px', color: '#888' }}>
                                        No data found
                                    </td>
                                </tr>
                            ) : (
                                currentPosts.map((item, index) => (
                                    <tr key={index}>
                                        <td>{postsPerPage * (currentPage - 1) + index + 1}</td>
                                        <td>{item.district || "-"}</td>
                                        <td>{item.school_id || "-"}</td>
                                        <td>{item.school_name || "-"}</td>
                                        <td>{item.student_name || "-"}</td>
                                        <td>{item.student_class || "-"}</td>
                                        <td>{item.gender || "-"}</td>
                                        <td>{item.phone_1 || "-"}</td>
                                        <td>{item.entry_date || "-"}</td>
                                        <td>{item.source || "-"}</td>
                                        {user === "Super Admin" && <>
                                            <td>{item.assigned_to_name || "-"}</td>
                                            <td>{getStatusBadge(item.status)}</td>
                                        </>}
                                        <td>
                                            <div style={{ display: 'flex', gap: '5px' }}>
                                                <button className="btn btn-success btn-sm" style={{ fontSize: '10px', padding: '2px 5px' }} onClick={() => handleActionClick('Prospect', item.id)}>Prospect</button>
                                                <button className="btn btn-danger btn-sm" style={{ fontSize: '10px', padding: '2px 5px' }} onClick={() => handleActionClick('Not Interested', item.id)}>X</button>
                                                <button className="btn btn-primary btn-sm" style={{ fontSize: '15px', padding: '2px 5px' }} onClick={() => handleReassignClick(item)}><RiExchangeFundsLine style={{ color: 'white' }} /></button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                )}

                <div style={{ float: "right" }}>{showPagination()}</div>
            </div>
        );
    };

    const [selectedStaffdp, setSelectedStaffdp] = useState(null);
    const handleStaffSelectdropdown = (selectedOption) => {
        setAssignFilter(selectedOption);

        // If you want to store only the ID in a separate state as well:
        // setAssignedTo(selectedOption?.value || null);
    };

    return (
        <Maincomponent tabname={"Lead"}>
            <div className="component-sub">
                <div className="component-sub1">
                    <div className="multistephead">
                        <b>LEAD</b>
                    </div>

                    <br />

                    {/* <div className="Billcompmain">

                    </div>

                    <br />
                    <br /> */}

                    <div className="Billcompmain">
                        <Tablecomp data={data} />
                    </div>
                </div>
            </div>

            {/* ASSIGN MODAL */}
            <Modal
                title="Assign Data"
                open={showAssignModal}
                onCancel={() => setShowAssignModal(false)}
                footer={null}
                width={1000}

            >
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
                    <h4>Assign Unassigned Data</h4>
                    <b>Total Unassigned (Filtered): {unassignedCount}</b>
                </div>

                <div style={{ display: "flex", gap: "20px" }}>
                    {/* Left Column: School Filter */}
                    <div style={{ flex: 1 }}>
                        <h5>Filter by School</h5>
                        <Select
                            options={schoolList}
                            isMulti
                            value={selectedSchools}
                            onChange={handleSchoolSelect}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            placeholder="Select Schools..."
                            className="basic-multi-select"
                            classNamePrefix="select"
                        />
                    </div>

                    {/* Right Column: Staff Selection */}
                    <div style={{ flex: 1, borderLeft: "1px solid #eee", paddingLeft: "20px" }}>
                        <h5>Select Staff</h5>
                        <Checkbox.Group
                            style={{ width: "100%", display: "flex", flexDirection: "column", gap: "8px" }}
                            onChange={handleStaffSelect}
                            value={selectedStaff}
                        >
                            {staffList.map((staff) => (
                                <Checkbox key={staff.Name} value={staff.id}>{staff.Name}</Checkbox>
                            ))}
                        </Checkbox.Group>
                    </div>
                </div>

                <hr style={{ margin: "20px 0" }} />

                {/* Bottom: Distribution Plan */}
                <div>
                    <h5>Distribution Plan</h5>
                    {assignPlan.length === 0 ? (
                        <p style={{ color: "#888" }}>Select schools and staff to see distribution.</p>
                    ) : (
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Staff</th>
                                    <th>Assigned Count</th>
                                </tr>
                            </thead>
                            <tbody>

                                {assignPlan.map((p) => (
                                    <tr key={p.staff}>

                                        <td>{p.staff}</td>
                                        <td>{p.count}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>

                <div style={{ textAlign: "right", marginTop: "20px" }}>
                    <button className="buttoncompnent1" onClick={confirmAssign} disabled={assignPlan.length === 0}>
                        Confirm Assign
                    </button>
                </div>
            </Modal>

            {/* ACTION MODAL */}
            <Modal
                title={`${currentAction} Action`}
                open={actionModalVisible}
                onCancel={() => setActionModalVisible(false)}
                onOk={submitAction}
                okText="Confirm"
                confirmLoading={actionLoading}
            >
                {currentAction === 'Not Interested' ? (
                    <div>
                        <p>Please select rejection reason(s):</p>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <Checkbox
                                checked={rejectionReasons.not_interested}
                                onChange={(e) => setRejectionReasons({ ...rejectionReasons, not_interested: e.target.checked })}
                            >
                                Not Interested
                            </Checkbox>
                            <Checkbox
                                checked={rejectionReasons.already_joined_elsewhere}
                                onChange={(e) => setRejectionReasons({ ...rejectionReasons, already_joined_elsewhere: e.target.checked })}
                            >
                                Already Joined Elsewhere
                            </Checkbox>
                            <Checkbox
                                checked={rejectionReasons.fees_too_high}
                                onChange={(e) => setRejectionReasons({ ...rejectionReasons, fees_too_high: e.target.checked })}
                            >
                                Fees Too High
                            </Checkbox>
                            <Checkbox
                                checked={rejectionReasons.course_not_relevant}
                                onChange={(e) => setRejectionReasons({ ...rejectionReasons, course_not_relevant: e.target.checked })}
                            >
                                Course Not Relevant
                            </Checkbox>
                            <Checkbox
                                checked={rejectionReasons.parents_not_interested}
                                onChange={(e) => setRejectionReasons({ ...rejectionReasons, parents_not_interested: e.target.checked })}
                            >
                                Parents Not Interested
                            </Checkbox>
                            <Checkbox
                                checked={rejectionReasons.prefers_online_classes}
                                onChange={(e) => setRejectionReasons({ ...rejectionReasons, prefers_online_classes: e.target.checked })}
                            >
                                Prefers Online Classes
                            </Checkbox>
                            <Checkbox
                                checked={rejectionReasons.not_eligible_for_course}
                                onChange={(e) => setRejectionReasons({ ...rejectionReasons, not_eligible_for_course: e.target.checked })}
                            >
                                Not Eligible for Course
                            </Checkbox>
                            <Checkbox
                                checked={rejectionReasons.will_join_later}
                                onChange={(e) => setRejectionReasons({ ...rejectionReasons, will_join_later: e.target.checked })}
                            >
                                Will Join Later
                            </Checkbox>
                            <Checkbox
                                checked={rejectionReasons.invalid_contact}
                                onChange={(e) => setRejectionReasons({ ...rejectionReasons, invalid_contact: e.target.checked })}
                            >
                                Invalid Contact
                            </Checkbox>
                            <Checkbox
                                checked={rejectionReasons.no_response}
                                onChange={(e) => setRejectionReasons({ ...rejectionReasons, no_response: e.target.checked })}
                            >
                                No Response
                            </Checkbox>
                            <Checkbox
                                checked={rejectionReasons.duplicate_lead}
                                onChange={(e) => setRejectionReasons({ ...rejectionReasons, duplicate_lead: e.target.checked })}
                            >
                                Duplicate Lead
                            </Checkbox>
                            <Checkbox
                                checked={rejectionReasons.out_of_service_area}
                                onChange={(e) => setRejectionReasons({ ...rejectionReasons, out_of_service_area: e.target.checked })}
                            >
                                Out of Service Area / Too Far
                            </Checkbox>
                        </div>
                    </div>
                ) : currentAction === 'Prospect' ? (
                    <div>
                        <p>Please select status progression(s):</p>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <Checkbox checked={statusProgression.base_entry} onChange={(e) => setStatusProgression({ ...statusProgression, base_entry: e.target.checked })}>Base Entry</Checkbox>
                            <Checkbox checked={statusProgression.verified} onChange={(e) => setStatusProgression({ ...statusProgression, verified: e.target.checked })}>Verified</Checkbox>
                            <Checkbox checked={statusProgression.responded} onChange={(e) => setStatusProgression({ ...statusProgression, responded: e.target.checked })}>Responded</Checkbox>
                            <Checkbox checked={statusProgression.qualified_lead} onChange={(e) => setStatusProgression({ ...statusProgression, qualified_lead: e.target.checked })}>Qualified Lead</Checkbox>
                            <Checkbox checked={statusProgression.new_lead} onChange={(e) => setStatusProgression({ ...statusProgression, new_lead: e.target.checked })}>New Lead</Checkbox>
                            <Checkbox checked={statusProgression.contacted} onChange={(e) => setStatusProgression({ ...statusProgression, contacted: e.target.checked })}>Contacted</Checkbox>
                            <Checkbox checked={statusProgression.info_shared} onChange={(e) => setStatusProgression({ ...statusProgression, info_shared: e.target.checked })}>Info Shared</Checkbox>
                            <Checkbox checked={statusProgression.counselling_scheduled} onChange={(e) => setStatusProgression({ ...statusProgression, counselling_scheduled: e.target.checked })}>Counselling Scheduled</Checkbox>
                            <Checkbox checked={statusProgression.demo_scheduled} onChange={(e) => setStatusProgression({ ...statusProgression, demo_scheduled: e.target.checked })}>Demo Scheduled</Checkbox>
                            <Checkbox checked={statusProgression.counselling_done} onChange={(e) => setStatusProgression({ ...statusProgression, counselling_done: e.target.checked })}>Counselling Done</Checkbox>
                            <Checkbox checked={statusProgression.demo_done} onChange={(e) => setStatusProgression({ ...statusProgression, demo_done: e.target.checked })}>Demo Done</Checkbox>
                            <Checkbox checked={statusProgression.fees_discussion_ongoing} onChange={(e) => setStatusProgression({ ...statusProgression, fees_discussion_ongoing: e.target.checked })}>Fees Discussion Ongoing</Checkbox>
                            <Checkbox checked={statusProgression.parent_approval_pending} onChange={(e) => setStatusProgression({ ...statusProgression, parent_approval_pending: e.target.checked })}>Parent Approval Pending</Checkbox>
                            <Checkbox checked={statusProgression.form_issued} onChange={(e) => setStatusProgression({ ...statusProgression, form_issued: e.target.checked })}>Form Issued</Checkbox>
                            <Checkbox checked={statusProgression.token_paid} onChange={(e) => setStatusProgression({ ...statusProgression, token_paid: e.target.checked })}>Token Paid</Checkbox>
                            <Checkbox checked={statusProgression.full_payment_pending} onChange={(e) => setStatusProgression({ ...statusProgression, full_payment_pending: e.target.checked })}>Full Payment Pending</Checkbox>
                            <Checkbox checked={statusProgression.converted} onChange={(e) => setStatusProgression({ ...statusProgression, converted: e.target.checked })}>Converted</Checkbox>
                        </div>
                    </div>
                ) : (
                    <div>
                        <p>Please enter remarks for {currentAction}:</p>
                        <Input.TextArea
                            rows={4}
                            value={actionRemarks}
                            onChange={(e) => setActionRemarks(e.target.value)}
                            placeholder="Enter remarks here..."
                        />
                    </div>
                )}
            </Modal>

            {/* REASSIGNMENT MODAL */}
            <Modal
                title="Reassign Lead"
                open={showReassignModal}
                onCancel={() => setShowReassignModal(false)}
                onOk={handleReassignSubmit}
                okText="Confirm Reassignment"
                width={600}
            >
                <div style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
                    {/* Left Column: Current Assignment */}
                    <div style={{ flex: 1 }}>
                        <h5>Currently Assigned To</h5>
                        <div style={{
                            padding: '15px',
                            border: '2px solid #1890ff',
                            borderRadius: '8px',
                            backgroundColor: '#e6f7ff',
                            textAlign: 'center'
                        }}>
                            <strong style={{ fontSize: '16px', color: '#1890ff' }}>
                                {reassignItem?.assigned_to_name || 'Unassigned'}
                            </strong>
                        </div>
                    </div>

                    {/* Right Column: New Assignment */}
                    <div style={{ flex: 1 }}>
                        <h5>Reassign To</h5>
                        <Select
                            options={staffList.map((staff) => ({
                                label: staff.Name,
                                value: staff.id,
                            }))}
                            value={newAssignee}
                            onChange={setNewAssignee}
                            placeholder="Select new staff member..."
                            className="basic-select"
                            classNamePrefix="select"
                        />
                    </div>
                </div>

                {reassignItem && (
                    <div style={{ marginTop: '20px', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                        <p style={{ margin: '5px 0' }}><strong>Lead Details:</strong></p>
                        <p style={{ margin: '5px 0' }}>Student: {reassignItem.student_name}</p>
                        <p style={{ margin: '5px 0' }}>School: {reassignItem.school_name}</p>
                        <p style={{ margin: '5px 0' }}>Phone: {reassignItem.phone_1}</p>
                    </div>
                )}
            </Modal>
        </Maincomponent >
    );
}
